<script lang="ts">
  import type { AppState } from '../state/app.svelte';
  import Icon from './Icon.svelte';
  let { title, description, state }: { title: string; description: string; state: AppState } =
    $props();
</script>

<header class="page-header">
  <div>
    <p class="page-kicker">Registro personale</p>
    <h1 tabindex="-1">{title}</h1>
    <p class="page-intro">{description}</p>
  </div>
  <div class="page-actions">
    <button
      class="icon-button theme-toggle"
      type="button"
      aria-label={state.dark ? 'Usa tema chiaro' : 'Usa tema scuro'}
      onclick={() => state.toggleTheme()}
    >
      <Icon name={state.dark ? 'sun' : 'moon'} />
    </button>
  </div>
</header>
